import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import { Wrapper, InnerWrapper } from './styles';
import useIsScrolledDown from '@spa/shared/hooks/useIsScrolledDown';

const FloatingBox = ({ show, close, children, ...props }) => {
  const ref = useRef();
  const isScrolledDown = useIsScrolledDown();

  return (
    <Wrapper show={show} ref={ref} isScrolledDown={isScrolledDown}>
      <InnerWrapper {...props}>{children}</InnerWrapper>
    </Wrapper>
  );
};

FloatingBox.propTypes = {
  show: PropTypes.bool,
  close: PropTypes.func,
  title: PropTypes.string,
  children: PropTypes.node
};

export default FloatingBox;
